import { useMemo } from "react";
import { useQuery } from "@apollo/client/react";

import { GET_INTENT_PROJECT_INTEGRATION } from "./gql";

const useIntentProjectIntegration = (intentProjectId: string) => {
  const { data, loading, error } = useQuery(GET_INTENT_PROJECT_INTEGRATION, {
    variables: { id: intentProjectId },
    skip: !intentProjectId,
  });

  const awsIntegrationAttachment = useMemo(
    () => data?.intentProject?.awsIntegrationIntentProjectAttachment,
    [data?.intentProject?.awsIntegrationIntentProjectAttachment]
  );

  return {
    awsIntegrationAttachment,
    loading,
    error,
  };
};

export default useIntentProjectIntegration;
